var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6 23.8C47.6 10.64 36.96 0 23.8 0C10.64 0 0 10.64 0 23.8C0 36.96 10.64 47.6 23.8 47.6C36.96 47.6 47.6 36.96 47.6 23.8ZM2.8 23.8C2.8 12.18 12.18 2.8 23.8 2.8C35.42 2.8 44.8 12.18 44.8 23.8C44.8 35.42 35.42 44.8 23.8 44.8C12.18 44.8 2.8 35.42 2.8 23.8Z",
    fill: "#658479"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1806 35.4197L14.5606 23.7997L26.1806 12.1797L24.2206 10.2197L10.6406 23.7997L24.2206 37.3797L26.1806 35.4197Z",
    fill: "#658479"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6016 22.3994V25.1994H36.4016V22.3994H12.6016Z",
    fill: "#658479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevBtn);
export default __webpack_public_path__ + "static/media/PrevBtn.692c72d6aa58d8fd3a60c0e3c3b06727.svg";
export { ForwardRef as ReactComponent };